import React, { useEffect, useState, useRef, useContext } from 'react'
import { MaterialsDropdownContainer, MaterialOptionDiv, MaterialOptionText } from './style'
import axios from 'axios'
import CertificatesContext from '../../../../../../contexts/CertificatesContext'

interface FormatType {
  id: number
  type: string
}

interface MaterialsType {
  description: string
  codeId: number
  trackingNumber: string
  format: FormatType
  heatNumber: {id:number, heatNumber:string}
}

interface ParamsType {
  quantity: number
  search: string
}

interface propsType {
  search:string
  open:React.Dispatch<React.SetStateAction<boolean>>
  setNewSearch:React.Dispatch<React.SetStateAction<string>>
}

const MaterialsDropdown: React.FC<propsType> = (props) => {
  const { setCertificate } = useContext(CertificatesContext)
  const [ materials, setMaterials ] = useState<MaterialsType[]>([])
  const [ paramsToBack, setParamsToBack ] = useState<ParamsType>({
    quantity: 10,
    search: props.search
  })
  
  useEffect(() => {
    setParamsToBack(prevParams => ({
      ...prevParams,
      search:props.search
    }))
  },[props.search])

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BASE_URL}/materials-to-certificates`, {
      params: paramsToBack
    })
      .then(response => {
        setMaterials(response.data)
      })
      .catch(error => {
        console.error(error)
      })
  }, [paramsToBack])

    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        props.open(false)
      }
    }
  
    useEffect(() => {
      document.addEventListener('mousedown', handleClickOutside)
      return () => {
        document.removeEventListener('mousedown', handleClickOutside)
      }
    }, [])

  const dropdownRef = useRef<HTMLDivElement | null>(null)

  const handleScroll = () => {
    if (dropdownRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = dropdownRef.current
      if (scrollTop + clientHeight >= scrollHeight - 5) {
        setParamsToBack(prevParams => ({
          ...prevParams,
          quantity: prevParams.quantity + 10
        }))
      }
    }
  }

  return (
    <MaterialsDropdownContainer ref={dropdownRef} onScroll={handleScroll}>
      {materials.map((item, index) => (
        <MaterialOptionDiv key={index} onClick={() => {
          setCertificate(prev => ({
            ...prev,
            material:item.description,
            heatNumber:item.heatNumber
          }))
          props.open(false)
          props.setNewSearch(item.description)
        }
        }>
          <MaterialOptionText>
            {item.description.length > 29 ? `${item.description.slice(0, 29)}...` : item.description}
          </MaterialOptionText>
        </MaterialOptionDiv>
      ))}
    </MaterialsDropdownContainer>
  )
}

export default MaterialsDropdown